export default __webpack_public_path__ + "static/media/promoted.3bb7a538.png";